import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./WalletTermsOfUseModal.module.scss";

interface WalletTermsOfUseModalProps {
	isCreating?: boolean;
	onAccept: () => void;
	onClose: () => void;
}

export const WalletTermsOfUseModal: React.FC<WalletTermsOfUseModalProps> = ({ isCreating = false, onAccept, onClose }) => {
	const { t } = useTranslation();
	const termsSections = [
		{ title: t("common.labels.walletTermsOfUseSection1Title"), body: t("common.labels.walletTermsOfUseSection1Body") },
		{ title: t("common.labels.walletTermsOfUseSection2Title"), body: t("common.labels.walletTermsOfUseSection2Body") },
		{ title: t("common.labels.walletTermsOfUseSection3Title"), body: t("common.labels.walletTermsOfUseSection3Body") },
		{ title: t("common.labels.walletTermsOfUseSection4Title"), body: t("common.labels.walletTermsOfUseSection4Body") },
		{ title: t("common.labels.walletTermsOfUseSection5Title"), body: t("common.labels.walletTermsOfUseSection5Body") },
		{ title: t("common.labels.walletTermsOfUseSection6Title"), body: t("common.labels.walletTermsOfUseSection6Body") },
	];
	return (
		<div className={styles.overlay}>
			<div className={styles.modal}>
				<div className={styles.header}>
					<button className={styles.closeBtn} onClick={onClose} disabled={isCreating} aria-label={t("wallet.web.close")}>
						✕
					</button>
					<span className={styles.title}>{t("common.labels.walletTermsOfUseTitle")}</span>
					<div className={styles.headerSpacer} />
				</div>
				<hr className={styles.divider} />
				<div className={styles.body}>
					{termsSections.map(section => (
						<div key={section.title}>
							<p className={styles.sectionTitle}>{section.title}</p>
							<p className={styles.sectionBody}>{section.body}</p>
						</div>
					))}
				</div>
				<div className={styles.footer}>
					<button className={styles.acceptBtn} onClick={onAccept} disabled={isCreating}>
						{isCreating ? t("wallet.web.creatingWallet") : t("common.labels.walletTermsOfUseAcceptButtonText")}
					</button>
				</div>
			</div>
		</div>
	);
};
